import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { StytchB2BProvider } from '@stytch/react/b2b'
import { StytchB2BUIClient } from '@stytch/vanilla-js/b2b'
import { initSentry } from './lib/sentry'
import { setupApiInterceptor } from './lib/api-client'
import App from './App.tsx'
import './index.css'

// Initialize Sentry
initSentry()

// Setup API interceptor for 401 handling
setupApiInterceptor()

const stytch = new StytchB2BUIClient(import.meta.env.STYTCH_PUBLIC_TOKEN || '')

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <StytchB2BProvider stytch={stytch}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </StytchB2BProvider>
    </React.StrictMode>,
)
